// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"148":"40294901","185":"7bd6a3c6","594":"4403eacb"}[chunkId] + ".js";
};